import { Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'star-rating',
    templateUrl: 'star.html',
})
export class StarRatingComponent implements OnChanges {
    @Input() rating: number;
    starWidth: number;

    ngOnChanges(): void {
        if(this.rating != undefined)
            this.starWidth = this.rating * 76 / 5;
        else
            this.starWidth = 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/virtual-sports/star-rating/star.ts